var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"cultivation-entry"},[(_vm.type)?_c('IxRes',[_vm._v("\n    frs.dlgCertIntegration.modals.harvestYearHelp.diagram.labels."+_vm._s(_vm.type)+"Cultivation\n  ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }